import React, { useState } from 'react';
import MDBox from 'src/components/md/MDBox';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';
import { alpha, Theme, InputAdornment } from '@mui/material';
import MDInput from 'src/components/md/MDInput';
import SearchIcon from '@mui/icons-material/Search';
import useProductsV2 from 'src/api/inventory-management/products/useProductsV2';
import ProductsTable from './ProductsTable';

const ProductsCard: React.FC = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');

  const {
    data: productsData,
    isLoading,
    isFetching,
    error,
  } = useProductsV2({
    page,
    pageSize,
    name: searchQuery.length > 0 ? searchQuery : undefined,
    // includes: ['attributes'],
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  if (error) {
    return (
      <MDBox m={4}>
        <ErrorMessage error={error} />
      </MDBox>
    );
  }

  return (
    <MDBox>
      <MDBox p={3} sx={{ maxWidth: '600px' }}>
        <MDInput
          value={searchQuery}
          onChange={handleSearchChange}
          fullWidth
          placeholder="Search products by name"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              backgroundColor: (theme: Theme) =>
                alpha(theme.palette.background.default, 0.8),
              '&:hover': {
                backgroundColor: (theme: Theme) =>
                  alpha(theme.palette.background.default, 0.95),
              },
              '&.Mui-focused': {
                backgroundColor: 'white',
              },
            },
          }}
        />
      </MDBox>
      <ProductsTable
        data={productsData?.edges || []}
        pageInfo={productsData?.pageInfo}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        isLoading={isLoading}
        isFetching={isFetching}
      />
    </MDBox>
  );
};

export default ProductsCard;
